
import { Action, Getter } from 'vuex-class'
import CalendarPicker from '@/components/calendar/calendar-picker.vue'
import { Device } from '@/store/types'
import { Options, Vue } from 'vue-class-component'
import { ResponseData } from '@/datamodel/response-data'

import { useI18n } from 'vue-i18n'
import router from '@/router'
import { getBetHistory, getBetHistoryDetails } from '@/api'
import { EventBuss } from '@/utils/constants'
import { BetRecord, BetRecordInfo } from 'vue'

@Options({
    components: {
        CalendarPicker
    }
})
class RuleView extends Vue {
    @Getter('device') device!: Device

    iN = useI18n().t
    isMobile = false

    $emit!: Vue['emit']
    emitter!: Vue['emitter']

    tabIndex = 0

    //#region Vue Methods
    beforeMount(): void {
        this.isMobile = this.device.display === 1
    }

    mounted(): void {
        //
    }
    //#endregion

    OnClickClose(): void {
        this.$emit('close')
    }
}

export default RuleView
